/**
 * Youtube Player Modal
 */
(function () {
    if ($('.icon-play, .videoSingle').length === 0) return;

    // DOM (se crea una vez)
    const $videoBox = $(`
    <div class="Video-box" data-modal="modal" style="display:none;">
      <span class="video-close"><i class="far fa-times-circle"></i></span>
      <div class="Video-data"></div>
      <a class="BtnStd BtnStd-primary videoLink d-none" target="_blank" rel="noopener"></a>
    </div>
  `);

    const $disclaimer = $('<div class="video-disclaimer-box"></div>');
    const $overlay = $('<div class="OverlayModal" style="display:none;"></div>');

    $('main').append($videoBox, $overlay, $disclaimer);

    // ---- Helpers para leer data-* en ambos formatos (camelCase y kebab-case) ----
    function getAttrAny($el, names) {
        for (const n of names) {
            const v = $el.attr(n);
            if (v != null && String(v).trim() !== '') return v;
        }
        return null;
    }

    // Extrae ID de YouTube si viene URL/iframe, si ya es ID lo deja.
    function normalizeYouTubeId(raw) {
        if (!raw) return null;
        const s = String(raw).trim();

        // Si ya parece ID (11 chars)
        if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;

        // Buscar en iframe src
        const iframeMatch = s.match(/src\s*=\s*["']([^"']+)["']/i);
        const maybeUrl = iframeMatch ? iframeMatch[1] : s;

        // watch?v=, youtu.be/, /embed/
        const m = maybeUrl.match(
            /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/i
        );
        return m ? m[1] : null;
    }

    // Cargar API una vez
    function loadYouTubeAPI() {
        if (window.YT && window.YT.Player) return;
        if (document.querySelector('script[data-yt-api]')) return;

        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.async = true;
        tag.setAttribute('data-yt-api', '1');
        document.head.appendChild(tag);
    }
    loadYouTubeAPI();

    let player = null;
    let currentVideoId = null;

    function openModal({ videoId, disclaimerText, link, linkText }) {
        if (!videoId) return;

        $disclaimer.html(disclaimerText || '');

        if (link) {
            $videoBox
                .find('.videoLink')
                .removeClass('d-none')
                .attr('href', link)
                .text(linkText || link);
        } else {
            $videoBox.find('.videoLink').addClass('d-none').attr('href', '').text('');
        }

        $overlay.show();
        $videoBox.show().addClass('showme');

        // Esperar a que YT esté listo
        const wait = setInterval(() => {
            if (window.YT && window.YT.Player) {
                clearInterval(wait);
                createOrLoadPlayer(videoId);
            }
        }, 50);
    }

    function createOrLoadPlayer(videoId) {
        const $container = $videoBox.find('.Video-data');

        // Si es el mismo video y ya existe player, solo play
        if (player && currentVideoId === videoId) {
            try {
                player.playVideo();
            } catch (e) {}
            return;
        }

        // Si existe otro player, destruirlo
        if (player) {
            try {
                player.destroy();
            } catch (e) {}
            player = null;
            $container.empty();
        }

        // Crear nuevo div contenedor
        const iframeId = 'yt_iframe_' + Date.now();
        $container.html(`<div id="${iframeId}"></div>`);
        currentVideoId = videoId;

        player = new YT.Player(iframeId, {
            width: '100%',
            height: '100%',
            videoId: videoId,
            playerVars: {
                modestbranding: 1,
                rel: 0,
                iv_load_policy: 3,
                autoplay: 1,
            },
        });
    }

    function closeModal() {
        $videoBox.removeClass('showme').hide();
        $overlay.hide();
        $disclaimer.empty();

        if (player) {
            try {
                player.stopVideo();
            } catch (e) {}
            try {
                player.destroy();
            } catch (e) {}
            player = null;
        }
        currentVideoId = null;
        $videoBox.find('.Video-data').empty();
    }

    // Click en play (delegado) — soporta slick clones y ambos estilos de data-attrs
    $(document).on('click', '.icon-play, .videoSingle', function (e) {
        // Solo si realmente es un trigger de video
        const $el = $(this);

        const rawVideo = getAttrAny($el, [
            'data-videoId',
            'data-video-id',
            'data-youtube-id',
            'data-youtubeId',
        ]);

        // Si no hay video id, no hacemos nada
        const videoId = normalizeYouTubeId(rawVideo);
        if (!videoId) return;

        e.preventDefault();

        const disclaimerText = getAttrAny($el, [
            'data-videoDisclaimer',
            'data-video-disclaimer',
        ]) || '';

        const link = getAttrAny($el, ['data-videoLink', 'data-video-link']);
        const linkText = getAttrAny($el, [
            'data-videoLinkText',
            'data-video-link-text',
        ]);

        openModal({ videoId, disclaimerText, link, linkText });
    });

    // Close
    $(document).on('click', '.video-close, .OverlayModal', function () {
        closeModal();
    });

    // ESC
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
    });
})();
